import { useEffect, useState } from 'react'

/**
 * Emite un tick que cambia en cada frame durante pan/zoom del chart.
 * Úsalo como dependencia de un efecto de render overlay para forzar que
 * los indicadores que dependen del rango visible se repinten frame a frame
 * (sin debounce de soltar). Se acumula un solo RAF por ráfaga de eventos.
 */
export function useChartPanTick(chartRef) {
  const [panTick, setPanTick] = useState(0)

  useEffect(() => {
    const chart = chartRef?.current
    if (!chart) return

    let rafId = null
    let pending = false

    const schedule = () => {
      if (pending) return
      pending = true
      rafId = requestAnimationFrame(() => {
        rafId = null
        pending = false
        setPanTick(t => (t + 1) % 1_000_000)
      })
    }

    const timeScale = chart.timeScale()
    timeScale.subscribeVisibleLogicalRangeChange(schedule)
    timeScale.subscribeVisibleTimeRangeChange(schedule)
    timeScale.subscribeSizeChange(schedule)

    return () => {
      if (rafId) cancelAnimationFrame(rafId)
      try { timeScale.unsubscribeVisibleLogicalRangeChange(schedule) } catch {}
      try { timeScale.unsubscribeVisibleTimeRangeChange(schedule) } catch {}
      try { timeScale.unsubscribeSizeChange(schedule) } catch {}
    }
  }, [chartRef])

  return panTick
}
